enum DealRottingCriteriaOptions {
  DEALS_ROTTING = "dealsRotting",
  DEALS_NOT_ROTTING = "dealsNotRotting",
}

export default DealRottingCriteriaOptions;
